import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Informacoes: React.FC = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>Informações</Typography>
      <Typography variant="body1" gutterBottom>
        Aqui você encontrará respostas para as perguntas mais frequentes sobre o nosso site Banca Simulados ANAC. O site tem como objetivo ser gratuito e ajudar estudantes de aviação a se preparar para a prova da ANAC.
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="h6">O que é o site Banca Simulados ANAC?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            O site Banca Simulados ANAC é a continuação de um projeto anterior com o mesmo nome que foi desativado. O site tem como objetivo ser gratuito e ajudar estudantes de aviação a se preparar para a prova da ANAC.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Typography variant="h6">Quais funcionalidades o site oferece?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            O site oferece simulados para ajudar na preparação para a prova da ANAC. Estamos constantemente adicionando novas funcionalidades para melhorar a experiência do usuário.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
          <Typography variant="h6">O site é gratuito?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Sim, o site é totalmente gratuito. Nosso objetivo é fornecer uma ferramenta de estudo acessível para todos os estudantes de aviação.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
          <Typography variant="h6">O site oferece materiais de apoio?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Atualmente, o site não oferece materiais de apoio além dos simulados. Estamos focados em melhorar a plataforma e adicionar novas funcionalidades para melhor atender nossos usuários.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header">
          <Typography variant="h6">O site cobra mensalidades?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Não, não cobramos mensalidades. O acesso ao site e suas funcionalidades é totalmente gratuito.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6a-content" id="panel6a-header">
          <Typography variant="h6">Como o site é desenvolvido?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            O site é desenvolvido aos poucos, com novas funcionalidades sendo adicionadas constantemente. Nosso objetivo é criar uma plataforma robusta e útil para os estudantes de aviação.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7a-content" id="panel7a-header">
          <Typography variant="h6">Como posso contribuir para o site?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Estamos abertos a sugestões e contribuições. Se você deseja ajudar no desenvolvimento ou tem sugestões de melhorias, entre em contato conosco através do site.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel8a-content" id="panel8a-header">
          <Typography variant="h6">Como posso reportar um problema no site?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Se você encontrar algum problema no site, por favor, reporte através da seção de contato disponível no site. Agradecemos seu feedback para melhorar nossa plataforma.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel9a-content" id="panel9a-header">
          <Typography variant="h6">Quais são os planos futuros para o site?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            Nosso plano futuro inclui adicionar mais funcionalidades, como novas categorias de simulados, melhorias na interface do usuário, e possíveis integrações com outras plataformas de estudo.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </Container>
  );
};

export default Informacoes;
